<section class="details">
  <p class="f-body-2xs f-medium f-muted">
    {{ `labels.orderDetails` | translate | uppercase }}
  </p>

  <div class="container f-body-s">
    <div class="item">
      <onyx-icon name="good-filled" [size]="14"></onyx-icon>

      <div class="wrapper">
        <p class="f-muted">{{ 'labels.loads' | translate }}</p>

        <div class="box">
          @for (good of loadingGoods(); track good.uuid) {
            <p class="box-item">
              {{ good.type ? (good.type.names | onyxLanguage) : good.typeName }}
              {{ good.unit.names | onyxLanguage }}

              @if (good.size) {
                · {{ good | goodQuantity }}
              } @else {
                {{ good.totalWeight | number }} kg
              }

              {{ !$last ? '·' : '' }}
            </p>
          }
        </div>
      </div>
    </div>

    @let outsourcingData = order().outsourcingData!;
    <div class="item">
      <onyx-icon name="vehicle-filled" [size]="14"></onyx-icon>

      <div class="wrapper">
        <p class="f-muted">{{ 'labels.vehicle' | translate }}</p>

        {{ outsourcingData.vehicleRegistrationNumber | fleetIdentifier }}

        @if (outsourcingData.trailerRegistrationNumber; as trailer) {
          <p>·</p>
          <p class="f-muted">{{ 'labels.semiTrailerOrTrailer' | translate }}</p>
          {{ trailer | fleetIdentifier }}
        }
      </div>
    </div>

    <div class="item">
      <onyx-icon name="user-filled" [size]="14"></onyx-icon>

      <div class="wrapper">
        <p class="f-muted">{{ 'labels.driver' | translate }}</p>

        @let primaryDriver = outsourcingData.primaryDriver;
        <div class="box">
          {{ primaryDriver.name }}
          {{ primaryDriver.phone | onyxPhone }}
        </div>

        @if (outsourcingData.secondaryDriver; as secondaryDriver) {
          <p>·</p>
          {{ secondaryDriver.name }}
          {{ secondaryDriver.phone | onyxPhone }}
        }
      </div>
    </div>

    <div class="item start">
      <onyx-icon name="more-alt-filled" [size]="14"></onyx-icon>

      <div class="wrapper">
        <p class="f-muted">{{ 'labels.cargoSpace' | translate }}</p>

        @let basicInformation = order().basicInformation;
        {{
          basicInformation.vehicleTypes
            | join: { maxLength: 2, i18nKey: DictionaryCode.VEHICLE_TYPE }
        }},

        <p class="f-muted">{{ 'labels.minSemiTrailerSize' | translate }}</p>

        {{
          `${DictionaryCode.ORDER_SEMI_TRAILER_SIZE}.${basicInformation.minSemiTrailerSize}`
            | translate
        }},

        <p class="f-muted">{{ 'labels.parameters' | translate }}</p>

        <app-parameters-cell
          [additionalParameters]="order().parameters"
          [visibleParametersCount]="null"
        ></app-parameters-cell>
      </div>
    </div>
  </div>
</section>
